// import './OurPackagesPageCss/OurPackageFirstSection.css';
import ServiceHeader from '../../ServiceComponents/ServiceHeader';

export default function TestPackageFirstSection() {
    return (
        <>
            <ServiceHeader
                childClass="testPackageFirstSection"
                breadcrumb={<>Tests</>}
                title="Tests"
            />
        </>
    )
}